import shave from 'shave';

document.addEventListener('DOMContentLoaded', () => {
  [... document.querySelectorAll('.posts-stacked__post')].map(el => {
    shave(el.querySelector('.card__content:not(.card__content--no-shave)'), 150, {character: '...'});
  });
});